(function() {
    'use strict';

    angular
        .module('iMatApp')
        .directive('imatPagination', pagination);

    function pagination () {
        
        return {
            restrict: 'EA',
            templateUrl: function(elem, attrs) {
                return attrs.paginationTemplateUrl || '/Scripts/iMatApp/views/paginationTemplate.html';
            },
            scope: {
                pageNumber: '=',
                totalCount: '=',
                pageSize: '=',
                paginationTemplateUrl: '@'
            },
            link: function (scope, element, attrs) {
                var calcPages = function() {
                    var visibleLinks = 4;
                    var pagesCount = scope.pagesCount();

                    scope.start = scope.pageNumber - visibleLinks < 1 ? 1 : scope.pageNumber - visibleLinks;
                    scope.end = scope.pageNumber + visibleLinks < pagesCount ? scope.pageNumber + visibleLinks : pagesCount;

                    scope.pages = [];
                    for (var i = scope.start; i <= scope.end; ++i) {
                        scope.pages.push(i);
                    }
                };
                scope.$watch('pageNumber', calcPages);
                scope.$watch('totalCount', calcPages);
                scope.$watch('pageSize', calcPages);

                scope.pagesCount = function () {
                    var pageSize = +scope.pageSize;
                    return Math.floor(scope.totalCount / pageSize) + (scope.totalCount % pageSize > 0 ? 1 : 0);
                };

                scope.shouldDisplayPagination = function () {
                    return scope.totalCount > scope.pageSize;
                }

                scope.isCurrent = function (index) {
                    return scope.pageNumber === index;
                };

                scope.setCurrent = function(index) {
                    scope.pageNumber = index;
                };

                scope.hasPrev = function() {
                    return scope.pageNumber > 1;
                };
                scope.prev = function() {
                    if (scope.hasPrev()) scope.pageNumber--;
                };

                scope.hasNext = function() {
                    return scope.pageNumber < scope.pagesCount();
                };
                scope.next = function() {
                    if (scope.hasNext()) scope.pageNumber++;
                };

                scope.firstPage = function() {
                    return scope.start === 1;
                };
                scope.goToFirstPage = function() {
                    if (!scope.firstPage()) scope.pageNumber = 1;
                };
                scope.lastPage = function() {
                    return scope.end === scope.totalCount;
                };
                scope.goToLastPage = function() {
                    if (!scope.lastPage()) scope.pageNumber = scope.totalCount;
                };
            }
        }
    }
})();